'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _DebugToolbar = require('./DebugToolbar');

var _DebugToolbar2 = _interopRequireDefault(_DebugToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        debugEnabled: state.getIn(['debug', 'enabled'])
    };
};

// Components


var DebugToolbarContainer = function DebugToolbarContainer(props) {
    var debugEnabled = props.debugEnabled;


    if (!debugEnabled) return null;

    return _react2.default.createElement(_DebugToolbar2.default, props);
};

DebugToolbarContainer.propTypes = {
    debugEnabled: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DebugToolbarContainer);


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/DebugToolbarContainer.js
// module id = 1937
// module chunks = 0